import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';

const BaseBox = styled('div', {
  shouldForwardProp,
})(
  {
    boxSizing: 'border-box',
  },
  css({
    fontFamily: 'body',
    boxSizing: 'border-box',
    minWidth: 0,
  })
);

export default BaseBox;
